import { MgLocalStorageKeys, LangEnum } from '@enums';
import { QuestionnaireQueryInterface } from '@types';
import { Option, AnswerQueryInterface, SubmissionQueryInterface } from '@types';
import { DownloadFormats } from '@constants/downloadFormats';

type MGLocalStorageType = {
  lettersFilters: SubmissionQueryInterface;
  lang: LangEnum;
  token: string;
  answersFilters: AnswerQueryInterface;
  lastUsedOption: Option<DownloadFormats>;
  questionnaireFilters: QuestionnaireQueryInterface;
  redirectPath: string;
};

export const getMgLocalStorage = <T = MGLocalStorageType[MgLocalStorageKeys]>(
  key: MgLocalStorageKeys
): T => {
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch (e) {
    return localStorage.getItem(key) as T;
  }
};

export function setMgLocalStorage<T = string>(key: MgLocalStorageKeys, value: T): void {
  if (typeof value !== 'string') {
    localStorage.setItem(key, JSON.stringify(value));
  } else {
    localStorage.setItem(key, value);
  }
}
